import BundleHeader from 'components/ProductPage/PdpBundling/BundleWidget/BundleHeader/BundleHeader';

export default BundleHeader;
